import * as ActionTypes from '../actions/actionTypes';

const defaultState = {
  widgets: {},
  connectors: {},
  selectedWidget: null,
};

const map = (state = defaultState, action) => {
  switch (action.type) {
    case ActionTypes.MAP_ADD_PORTAL_RESPONSE: {
      const { widget, key } = action.payload;
      const { widgets, selectedWidget, connectors } = state;
      let newSelectedWidget = selectedWidget;
      let newWidgets = { ...widgets };
      let newConnectors = { ...connectors };
      const newWidget = { ...widget, id: key };

      if (!(newWidget.id in newWidgets)) {
        newWidgets[newWidget.id] = { ...newWidget };
        newSelectedWidget = { ...newWidget };
        newConnectors = Object.keys(newConnectors).reduce((obj, itemKey) => {
          const tmpConnector = connectors[itemKey];
          const tmpObj = obj;
          tmpConnector.selected = false;
          if (tmpConnector.startWidget.key === widget.id) {
            tmpConnector.selected = true;
          } else if (tmpConnector.endWidget.key === widget.id) {
            tmpConnector.selected = true;
          }
          tmpObj[itemKey] = tmpConnector;
          return tmpObj;
        }, {});

        newWidgets = Object.keys(newWidgets).reduce((previous, itemKey) => {
          const tmp = previous;
          tmp[itemKey] = newWidgets[itemKey];
          tmp[itemKey].highlighted = false;
          return tmp;
        }, {});
      }

      return {
        ...state,
        widgets: newWidgets,
        selectedWidget: newSelectedWidget.id,
        connectors: newConnectors,
      };
    }

    case ActionTypes.MAP_SELECT_WIDGET: {
      const { connectors, widgets } = state;
      const { widget } = action.payload;
      let newConnectors = { ...connectors };
      const connectedWidgets = [];

      newConnectors = Object.keys(newConnectors).reduce((obj, key) => {
        const tmpConnector = connectors[key];
        const tmpObj = obj;
        tmpConnector.selected = false;
        if (tmpConnector.startWidget.key === widget) {
          tmpConnector.selected = true;
          connectedWidgets.push(tmpConnector.endWidget.key);
        } else if (tmpConnector.endWidget.key === widget) {
          tmpConnector.selected = true;
          connectedWidgets.push(tmpConnector.startWidget.key);
        }
        tmpObj[key] = tmpConnector;
        return tmpObj;
      }, {});

      let newWidgets = { ...widgets };
      newWidgets = Object.keys(newWidgets).reduce((previous, key) => {
        const tmp = previous;
        tmp[key] = newWidgets[key];
        tmp[key].highlighted = false;
        if (connectedWidgets.includes(newWidgets[key].id)) {
          tmp[key].highlighted = true;
        }
        return tmp;
      }, {});

      return {
        ...state,
        selectedWidget: widget,
        connectors: newConnectors,
        widgets: newWidgets,
      };
    }

    case ActionTypes.MAP_UPDATE_WIDGET_RESPONSE: {
      const { widget } = action.payload;
      const { widgets, connectors } = state;
      const newWidgets = { ...widgets };
      const newConnectors = [...connectors];
      if (!(widget.id in newWidgets)) {
        newWidgets[widget.id] = { ...widget };
      }
      return { ...state, widgets: newWidgets, connectors: newConnectors };
    }
    case ActionTypes.MAP_REMOVE_WIDGET_LOCAL:
    case ActionTypes.MAP_REMOVE_WIDGET: {
      const { widgetId } = action.payload;
      const { widgets, connectors } = state;
      let newWidgets = { ...widgets };
      let newConnectors = { ...connectors };
      newWidgets = Object.keys(newWidgets).reduce((previous, key) => {
        const tmp = previous;
        if (widgetId !== newWidgets[key].id) {
          tmp[key] = newWidgets[key];
        }
        return tmp;
      }, {});
      newConnectors = Object.keys(newConnectors).reduce((previous, currentKey) => {
        const tmp = previous;
        if (newConnectors[currentKey].startWidget.key === widgetId) {
          newWidgets[newConnectors[currentKey].endWidget.key].highlighted = false;
        } else if (newConnectors[currentKey].endWidget.key === widgetId) {
          newWidgets[newConnectors[currentKey].startWidget.key].highlighted = false;
        } else {
          tmp[currentKey] = newConnectors[currentKey];
        }
        return tmp;
      }, {});
      return { ...state, widgets: newWidgets, selectedWidget: {}, connectors: newConnectors };
    }

    case ActionTypes.MAP_ADD_CONNECTOR_RESPONSE: {
      const { connector, key } = action.payload;
      const { connectors, widgets } = state;
      const newConnectors = connectors;
      const { endWidget } = connector;
      const newConnector = { ...connector, selected: true };
      newConnectors[key] = newConnector;
      const newWidgets = { ...widgets };
      newWidgets[endWidget.key].highlighted = true;
      return { ...state, connectors: newConnectors, widgets: newWidgets };
    }

    case ActionTypes.MAP_REMOVE_CONNECTOR_LOCAL:
    case ActionTypes.MAP_REMOVE_CONNECTOR: {
      const { connectors: removeConnectorsList } = action.payload;
      const { connectors, widgets } = state;
      const unselectWidgets = [];
      const newConnectors = Object.keys(connectors).reduce((previous, currentKey) => {
        const tmp = previous;
        if (removeConnectorsList.includes(currentKey)) {
          unselectWidgets.push(connectors[currentKey].startWidget.key);
          unselectWidgets.push(connectors[currentKey].endWidget.key);
        } else {
          tmp[currentKey] = connectors[currentKey];
        }
        return tmp;
      }, {});

      let newWidgets = { ...widgets };
      newWidgets = Object.keys(newWidgets).reduce((previous, currentKey) => {
        const tmp = previous;
        tmp[currentKey] = newWidgets[currentKey];
        if (unselectWidgets.includes(currentKey)) {
          tmp[currentKey].highlighted = false;
        }
        return tmp;
      }, {});

      return { ...state, connectors: newConnectors, widgets: newWidgets };
    }

    case ActionTypes.MAP_UPDATE_RESPONSE: {
      const { connectors, widgets } = action.payload;
      return { ...state, connectors, widgets };
    }

    case ActionTypes.MAP_LOAD: {
      const { connectors, widgets, selectedWidget } = action.payload;
      return { ...state, widgets, selectedWidget, connectors };
    }

    default:
      return state;
  }
};

export default map;



// WEBPACK FOOTER //
// ./src/redux/reducers/map.js